import React, { Component } from 'react';
import './styles.css';

import Table from '../../../../components/Table';

export default class TimeDashboard extends Component {
  render() {
    const { data, averages } = this.props;

    return (
      <div>
        <div style={{
          display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 16, marginBottom: 42,
        }}
        >
          <div style={{ border: '1px solid var(--mid-gray-chart)', marginRight: 16 }}>
            <div
              style={{
                margin: '20px 34px 16px 34px', fontSize: 18, fontWeight: 'bold', color: '#263465',
              }}
            >
              Tempo médio de duração da baixa
            </div>
            <div
              style={{
                fontSize: 64, fontWeight: 'bold', color: '#2580AC', textAlign: 'center', marginBottom: 40,
              }}
            >
              { averages.averageDischargeDuration }
            </div>
          </div>
          <div style={{ border: '1px solid var(--mid-gray-chart)' }}>
            <div
              style={{
                margin: '20px 34px 16px 34px', fontSize: 18, fontWeight: 'bold', color: '#263465',
              }}
            >
              Tempo médio de delay da transmissão
            </div>
            <div
              style={{
                fontSize: 64, fontWeight: 'bold', color: '#2580AC', textAlign: 'center', marginBottom: 40,
              }}
            >
              { averages.averageTransmissionDelay }
            </div>
          </div>
        </div>
        <Table
          onRowClick={this._onRowClick}
          className="ManifestsInTransit__table"
          isFetching={false}
          wrapCells
          headers={[
            {
              title: 'Data e hora da baixa',
              highlighted: true,
            },
            {
              title: 'Permanência',
              highlighted: true,
              align: 'center',
            },
            {
              title: 'Transmissão',
              highlighted: true,
              alignment: 'center',
            },
            {
              title: 'Motorista',
              highlighted: true,
              alignment: 'center',
            },
            {
              title: 'Placa',
              highlighted: true,
              alignment: 'center',
            },
            {
              title: 'Manifesto',
              highlighted: true,
              alignment: 'center',
            },
            {
              title: 'CTE',
              highlighted: true,
              alignment: 'center',
            },
            {
              title: 'Baixa / Foto',
              highlighted: true,
              alignment: 'center',
            },
          ]}
          data={data}
        />
      </div>
    );
  }
}
